export { default } from './articleSummary';
